/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import { Trash2 } from "lucide-react";

function Dropdown({
  labelName,
  setInputText,
  options = [],
  value,
  disabled,
  isMandatary,
  type,
  search,
}) {
  const [searchText, setSearchText] = useState("");
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const onHandleChange = (e) => {
    if (e.target.value) {
      setInputText(JSON.parse(e.target.value));
    }
  };

  const onChangeClear = () => {
    setInputText("");
    setSearchText("");
    setOpen(false);
  };

  let link = window.location.pathname;

  useEffect(() => {
    const closeDropdown = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", closeDropdown);
    return () => document.removeEventListener("mousedown", closeDropdown);
  }, []);

  // const getLabel = (item) =>
  //   item?.stage
  //     ? item?.stage
  //     : item?.collegeId?.collegeName
  //       ? item?.collegeId?.collegeName
  //       : item?.type && type === "type"
  //         ? item?.type
  //         : item?.en
  //           ? item?.en?.name
  //           : item?.name;

  //     console.log("options", options);      
  // const filteredOptions = Array.isArray(options)
  //   ? options?.filter((item) =>
  //       getLabel(item)?.toLowerCase().includes(searchText.toLowerCase()),
  //     )
  //   : [];

  const getLabel = (item) => {
  if (item?.stage) return item.stage;

  if (item?.collegeId?.collegeName)
    return item.collegeId.collegeName;

  if (item?.type && type === "type") return item.type;

  if (item?.en?.name) return item.en.name;

  return item?.name || "";
};

  const filteredOptions = Array.isArray(options)
  ? options.filter((item) => {
      const label = getLabel(item);
      return String(label || "")
        .toLowerCase()
        .includes(searchText.toLowerCase());
    })
  : [];

  return (
    <div className="d-flex mb-2 w-100 align-items-center gap-1">
      {!search ? (
        <select
          className="form-select border rounded p-2"
          style={{ flex: 1, minWidth: 0 }}
          value={JSON.stringify(value)}
          onChange={(e) => {
            onHandleChange(e);
          }}
          disabled={disabled}
        >
          <option value="">{labelName}</option>
          {options?.length > 0
            ? options?.map((item) => {
                return (
                  <option key={item?._id} value={JSON.stringify(item)}>
                    {item?.stage
                      ? item?.stage
                      : item?.collegeId?.collegeName
                        ? item?.collegeId?.collegeName
                        : item?.type && type === "type"
                          ? item?.type
                          : item?.en
                            ? item?.en?.name
                            : item?.name}
                  </option>
                );
              })
            : null}
        </select>
      ) : (
        <div
          className="position-relative"
          ref={dropdownRef}
          style={{
            flex: 1,
            minWidth: 0,
            width: "100%",
            maxWidth: "100%",
          }}
        >
          <div
            className="form-select border rounded p-2 d-flex align-items-center"
            style={{
              flex: 1,
              minWidth: 0,
              width: "100%",
              cursor: "pointer",
            }}
            onClick={() => !disabled && setOpen(!open)}
          >
            {/* <SearchIcon fontSize="small" className="me-2 text-muted" /> */}
            {/* {value ? getLabel(value) : labelName} */}
            <span title={value ? getLabel(value) : ""}>
              {value ? getLabel(value) : labelName}
            </span>
          </div>

          {open && (
            <div className="dropdown-search-menu shadow border rounded bg-white mt-1">
              <input
                type="text"
                className="form-control border-0 border-bottom"
                placeholder="Search..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                autoFocus
              />

              <div className="search-options-list">
                {filteredOptions?.length > 0 ? (
                  filteredOptions.map((item) => (
                    <div
                      key={item?._id}
                      className="search-option-item"
                      onClick={() => {
                        setInputText(item);
                        setOpen(false);
                        setSearchText("");
                      }}
                    >
                      {getLabel(item)}
                    </div>
                  ))
                ) : (
                  <div className="p-2 text-muted">No results found</div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
      <button
        title="Remove"
        type="button"
        onClick={onChangeClear}
        disabled={disabled}
        style={{
          display:
            value && link !== "/SuperAdminPanel/aboutus" ? "flex" : "none",
          height: "33px",
          width: "31px",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          border: "1px solid #f09595",
          borderRadius: "6px",
          background: "#fcebeb",
          cursor: disabled ? "not-allowed" : "pointer",
          padding: 0,
          opacity: disabled ? 0.5 : 1,
        }}
      >
        {/* <DeleteIcon style={{ fontSize: 18, color: "#a32d2d" }} /> */}
         <Trash2 size={17} color="#a32d2d"/>
      </button>
      {isMandatary ? <span className="required ms-1 fs-6">*</span> : null}
    </div>
  );
}

export default React.memo(Dropdown);
